// extracted by mini-css-extract-plugin
export default {"list":"Step2-module__list-cF0rC4","listItem":"Step2-module__listItem-t7SCGS"};